export const isValidSerialNum = (serialNum) => {
    // Min. requirements: Hexadecimal 6 digits
    var serialNumRegex = /^[0-9a-zA-Z].{5,30}$/;
    if (serialNum === "" || serialNum === null) {
        return false;
    }
    if (!serialNumRegex.test(serialNum)) {
        return false;
    }
    return true;
}

export const isValidEmail = (email) => {
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/g;
    if (email == "" || email == null) {
        return true;
    }
    if (!emailRegex.test(email)) {
        return false;
    }
    return true;
}

export const isValidPassword = (password) => {
    // Min. Requirements: 12 characters, 1 uppercase, 1 lowercase, 1 numeric value, 1 symbol
    var pwdRegex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{12,30}$/;
    if (password === "" || password === null) {
        return false;
    }
    if (!pwdRegex.test(password)) {
        return false;
    }
    return true;
}

export const isValidCustomEncryption = (_, encryption) => {
    // Requirements: 8-32, A-Z, a-z, 0-9
    const regex = /^(?=.*[a-z])(?=.*[A-Z])[A-Za-z0-9]{8,32}$/;
    if (!encryption || regex.test(encryption)) {
        return Promise.resolve();
    }

    return Promise.reject(
        new Error("Encryption must be 8-32 characters, include uppercase and lowercase letters, and contain only letters and numbers.")
    );
}

export const validatePhoneNumber = (phone) => {
    if (phone) {
        phone = phone.replace(/\D/g, '')
    }
    return phone;
}

export const isValidPhoneNumber = (phone) => {
    var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/g;
    if (phone == "" || phone == null) {
        return true;
    }
    if (!phoneRegex.test(phone)) {
        return false;
    }
    return true;
}

export const maskPhoneNumber = (number) => {
    var x = number.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return number.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

export const validateVerificationCode = (code) => {
    if (code) {
        code = code.replace(/\D/g, '')
    }
    return code;
}

export const isValidVerificationCode = (code) => {
    // 6 digits code
    var verifyCodeRegex = /^[0-9].{5}$/;
    if (code == "" || code == null) {
        return true;
    }
    
    if (!verifyCodeRegex.test(code)) {
        return false;
    }
    return true;
}

export const isValidOracleID = (oracle) => {

    var oracleRegex  = /^\d[0-9]{4,5}$/g;
    if (oracle == "" || oracle == null) {
        return true;
    }

    if( oracle.toString().includes('<') || oracle.toString().includes('/>') ) { 
        return false; 
    }

    if (!oracleRegex.test(oracle.toString())) {
        return false;
    }
    return true;
}

export const isValidContractNumber = (contract) => {

    var contractRegex = /^[a-zA-Z0-9\b]{0,30}$/g; 

    if(contract === '' || !contract){
        return true;
    } 

    if(!contractRegex.test(contract)){
        return false;
    }

    return true;
}

export const isValidCIDR = (_, cidr) => {
    // IP format wth subnet 1-32
    const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\/(3[0-2]|[1-2][0-9]|[1-9])$/;

    if (!ipRegex.test(cidr)) {
        return Promise.reject(new Error('Please enter a valid IP address followed by a subnet mask'));
    }
    
    return Promise.resolve();
};

export const validateExcludedIP = (_, value) => {
    // Exclude specific DNS IP patterns such as "8.8.X.X and 1.1.1.X"
    const excludedPatterns = [/^8\.8\.\d{1,3}\.\d{1,3}$/, /^1\.1\.1\.\d{1,3}$/];

    const [ipPart] = value.split('/');

    if (excludedPatterns.some((pattern) => pattern.test(ipPart))) {
        return Promise.reject(new Error('IP addresses starting with 8.8.x.x or 1.1.1.x are not allowed'));
    }

    return Promise.resolve();
};

export const isValidIP = (_, ip) => {
    // Applies to: VLAN localIP, WAN IP, Gateway IP, DNS Resolver 1 & 2
    const ipPattern = /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/;
    
    if (!ipPattern.test(ip)) {
        return Promise.reject(new Error('Please enter a valid IP address'));
    }
    
    return Promise.resolve();
}

export const isValidVlanID = (_, vlanID) => {
    // Only allow VLANs from 1 to 4095
    if (!vlanID) return Promise.resolve();

    if (!/^\d+$/.test(vlanID)) {
        return Promise.reject("VLAN ID must be a number");
    }

    const num = Number(vlanID);
    
    if (num < 1 || num > 4095) {
        return Promise.reject("VLAN ID must be between 1 and 4095");
    }

    return Promise.resolve();
}

export const isValidMask = (_, value) => {
    // Only allow numbers from 1-32
    if (!value) return Promise.resolve();

    if (!/^\d+$/.test(value)) {
        return Promise.reject("Mask must be a number");
    }

    const num = Number(value);
    
    if (num < 1 || num > 32) {
        return Promise.reject("Mask must be between 1 and 32");
    }

    return Promise.resolve();
}